import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Hire = () => import("../components/content/recruitment/hire");
const Invited = () => import("../components/content/recruitment/invited");
const Transfer = () => import("../components/content/recruitment/transfer");

export const hireRoute = {
  path: "/hire",
  component: Hire,
   // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const invitedRoute = {
  path: "/invited-candidates",
  component: Invited,
   // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};

export const transferRoute = {
  path: "/transferred-candidates",
  component: Transfer,
   // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
